import { useMemo } from "react";

import { ProfileUserLocationDto, UserDepartmentDto } from "@/core/api/generated/v1";

import { useUserProfile } from "./useUserProfile";

export const useUserAffiliation = (): {
  isIniting: boolean;
  departments: UserDepartmentDto[] | undefined;
  locations: ProfileUserLocationDto[] | undefined;
  departmentIds: string[] | undefined;
  locationIds: string[] | undefined;
} => {
  const profile = useUserProfile();
  const userAffiliation = useMemo(() => {
    return {
      isIniting: !profile,
      departments: profile?.departments,
      locations: profile?.locations,
      departmentIds: profile?.departments?.map((x) => x.id || "").filter(Boolean),
      locationIds: profile?.locations?.map((x) => x.id || "").filter(Boolean),
    };
  }, [profile]);

  return userAffiliation;
};
